module.exports = __webpack_public_path__ + "assets/img/7.b97d7e9d.png";